<template>
    <div class="flex flex-col items-center justify-items-center lg:px-64 md:px-32 sm:px-16 px-3 mb-40">
        <h2 class="mt-16 mb-10 tracking-wider font-semibold text-center text-3xl">{{ $route.params.title }}</h2>
        <tailwind-image
            v-if="linkExists(0)"
            :link="links[0]"
            aspect-ratio="7/12"
            class="w-full"
        ></tailwind-image>
        <div class="mt-5">
        </div>
        <div class="grid grid-cols-2 w-full mt-5">
            <tailwind-image
                v-if="linkExists(1)"
                :link="links[1]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
            <tailwind-image
                v-if="linkExists(2)"
                :link="links[2]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
        </div>
        <tailwind-image
            v-if="linkExists(3)"
            :link="links[3]"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>
        <div class="grid grid-cols-2 w-full mt-5">
            <tailwind-image
                v-if="linkExists(4)"
                :link="links[4]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
            <tailwind-image
                v-if="linkExists(5)"
                :link="links[5]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
        </div>
        <tailwind-image
            v-if="linkExists(6)"
            :link="links[6]"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>
        <div class="grid grid-cols-2 w-full mt-5">
            <tailwind-image
                v-if="linkExists(7)"
                :link="links[7]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
            <tailwind-image
                v-if="linkExists(8)"
                :link="links[8]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
        </div>
        <tailwind-image
            v-for="iLink in allRemainingLinks"
            :key="'VueKey' + iLink"
            :link="iLink"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>
        <div class="mt-5">
            <span class="font-semibold">Entwurf und Realisierung</span><br />
            <p class="leading-tight">
                Prof. Dr. Markus Holzbach sowie Aldo Freund, Philip Kliem, Barbara Wildung, Benjamin Würkner, Nikita Bagdulin, Patrick König, Sarah Lilienthal, Martin Pohlmann, Nico Reinhardt<br />
                <br />
                <span class="font-semibold">Sound</span><br />
                Dominik Eulberg<br />
                <br />
                <span class="font-semibold">Projektionen</span><br />
                Paul Simon Heyduck, Raoul Wilken<br />
                <br />
                <span class="font-semibold">Sponsoren</span><br />
                Palmengarten Frankfurt, Dominik Eulberg, Sonosfera, satis&fy, Gründach e.k., Bagger Born GmbH, Gazeshop.de<br />
                <br />
                <span class="font-semibold">Dokumentation</span><br />
                Emily Wabitsch
                <br>
                Rudi Weißbeck
                <br />
                <br>
                Projekt an der Kunsthochschule HfG Offenbach
            </p>
        </div>
    </div>
</template>
<script>
import TailwindImage from '@/components/TailwindImage';


export default {
    components: {
        TailwindImage,
    },
    props: {},
    data ()
    {
        return {
            links: [
                require( '@/assets/img/pc/Halle_Leer 084.jpg' ),
                require( '@/assets/img/pc/Halle_Leer 009.jpg' ),
                require( '@/assets/img/pc/Halle_Leer 032.jpg' ),
                require( '@/assets/img/pc/Halle_Leer 056.jpg' ),
                require( '@/assets/img/pc/Halle_Leer 080.jpg' ),
                require( '@/assets/img/pc/Halle_Leer 083.jpg' ),
                require( '@/assets/img/pc/Halle_Leer 004.jpg' ),
                require( '@/assets/img/pc/Halle_Leer 090.jpg' ),
                require( '@/assets/img/pc/IMG_7947.jpg' ),
                require( '@/assets/img/pc/IMG_8086.jpg' ),
            ],
        };
    },
    methods: {
        linkExists ( index )
        {
            return index in this.links;
        }
    },
    created () { },
    computed: {
        allRemainingLinks ()
        {
            if ( !this.linkExists( 9 ) )
            {
                return [];
            } else
            {
                return this.links.slice( 9 );
            }
        }
    }
};
</script>